// Presentational card for one Application. The catalog landing owns
// filter/sort/grouping state; this component just renders props.
// Props shape matches the operator /api/v1/applications response.

export function ApplicationCard({ app, onOpen }) {
  const phase = app.phase?.toLowerCase() || '';
  const integrations = app.integrations || [];
  const capCount = app.capabilities?.length ?? 0;

  return (
    <div
      className="appCard"
      role="button"
      tabIndex={0}
      onClick={() => onOpen(app.name)}
      onKeyDown={(e) => {
        if (e.target !== e.currentTarget) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(app.name); }
      }}
    >
      <div className="topRow">
        <div className="icon">{app.name?.[0]?.toUpperCase() || '?'}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="nmRow">
            <div className="nm">{app.displayName || app.name}</div>
            {app.ownerGroup?.title && (
              <span className={`ownerPill${app.ownerGroup.type === 'external' ? ' external' : ''}`}>
                <span className="av">{(app.ownerGroup.title[0] || '?').toUpperCase()}</span>
                {app.ownerGroup.title}
              </span>
            )}
          </div>
          {app.launchURL ? (
            <a
              className="launch"
              href={app.launchURL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >Launch</a>
          ) : (
            <span className="launch none">no launch link · API-only</span>
          )}
        </div>
      </div>

      <div className="desc">{app.description}</div>

      <div className="facesRow">
        {integrations.length === 0 ? (
          <span className="facePill" style={{ borderStyle: 'dashed', color: 'var(--ink-soft)' }}>
            <span className="d" style={{ background: 'var(--pencil)' }} />
            no integrations
          </span>
        ) : (
          <>
            {integrations.slice(0, 4).map((integ, i) => (
              <span key={i} className={`facePill ${integ.type}`}>
                <span className="d" />
                {integ.providerRef || integ.type}
              </span>
            ))}
            {integrations.length > 4 && <span className="facePill count">+{integrations.length - 4}</span>}
          </>
        )}
      </div>

      {(app.entityTypes || []).length > 0 && (
        <div className="entRow">
          {app.entityTypes.map((e) => <span key={e} className="epill">{e}</span>)}
        </div>
      )}

      <div className="footRow">
        <span className={`status ${phase}`}><span className="s" />{phase || '—'}</span>
        <span className="access">
          <b>{capCount > 0 ? `${capCount} cap${capCount === 1 ? '' : 's'}` : '—'}</b>
        </span>
      </div>
    </div>
  );
}
